module.exports = __webpack_public_path__ + "img/no-result.87d15913.png";